"use client";

import { useCallback, useEffect, useState } from "react";

import AppContext from "./context";
import { Session } from "next-auth";
import { User } from "@/lib/auth";

const AppContextProvider = ({
  children,
  value,
}: {
  children: React.ReactNode;
  value: {
    session: Session | null;
  };
}) => {
  const [user, setUser] = useState<User | null>(value?.session?.user || null);
  const [isLoading] = useState(true);
  const isAuthenticated = !!user?.id;

  const logout = useCallback(() => {
    setUser(null);
  }, []);

  //   const userFetch = useCallback(async () => {
  //     const sessionData = await getSession();
  //     if (sessionData?.user) {
  //       const userData: User = {
  //         id: sessionData.user.id || "",
  //         firstName: sessionData.user.firstName || "",
  //         lastName: sessionData.user.lastName || "",
  //         username: sessionData.user.username || "",
  //         email: sessionData.user.email || "",
  //       };
  //       setUser(userData);
  //       return userData;
  //     }
  //     throw new Error("User not found");
  //   }, []);

  //   useEffect(() => {
  //     const initializeUser = async () => {
  //       try {
  //         setIsLoading(true);
  //         await userFetch();
  //       } catch (error) {
  //         console.log("No authenticated user found");
  //         setUser(null);
  //       } finally {
  //         setIsLoading(false);
  //       }
  //     };

  //     initializeUser();
  //   }, [userFetch]);

  useEffect(() => {
    setUser(value?.session?.user || null);
  }, [value?.session]);

  const val = {
    user,
    isLoading,
    isAuthenticated,
    setUser,
    logout,
    session: value?.session,
  };

  return <AppContext.Provider value={val}>{children}</AppContext.Provider>;
};

export default AppContextProvider;
